export { default as Dialog } from './Dialog';

export const ModuleSteps = {
    Dialog: 'Dialog'
};
